export default __webpack_public_path__ + "static/media/delete.c61d3226.svg";